import { useStyles } from '@team-griffin/stylr';
import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px, Theme } from '@uds/theme-utils';
import { opacify } from '@ux/style-utils';
import longhand from '@team-griffin/css-longhand';

export default ({
  theme: { spacing, palette },
  first,
  last,
}: {
  theme: Theme;
  first: boolean | undefined;
  last: boolean | undefined;
}) =>
  useStyles(
    {
      default: {
        root: {
          ...cssSides('padding', Side.Y, gu2px(2, spacing)),
          ...cssSides('margin', Side.A, 0),
          ...longhand('borderTop', {
            style: 'solid',
            width: 1,
            color: opacify(palette.grey06, 0.2),
          }),
        },
      },

      first: {
        root: {
          paddingTop: 0,
          borderTopWidth: 0,
        },
      },

      last: {
        root: {
          paddingBottom: 0,
        },
      },
    },
    [{ first }, { last }],
  );
